export default __webpack_public_path__ + "static/media/close.139b2ef6.svg";